import { Rarity, Sport } from '#src/__generated__/globalTypes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

import { useSeriesNav } from '../commonGame/useSeriesNav';
import { useFeatureFlags } from '../useFeatureFlags';

const AUTHORIZED_RARITIES = [
  Rarity.common,
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

export const useAvailableRarities = (): Rarity[] => {
  const { sport } = useSportContext();
  const {
    flags: { enableNavToggleProSet = false },
  } = useFeatureFlags();
  const isSimplifiedNav = useSeriesNav();
  if (sport === Sport.BASEBALL) {
    return AUTHORIZED_RARITIES.filter(r => r !== Rarity.common);
  }
  if (enableNavToggleProSet) {
    if (isSimplifiedNav) {
      return [Rarity.common];
    }
    return AUTHORIZED_RARITIES.filter(r => r !== Rarity.common);
  }
  return AUTHORIZED_RARITIES;
};
